"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isNumeric = function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};

var _default = isNumeric;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/_util/isNumeric.js
// module id = 832
// module chunks = 1